var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner-border text-info",attrs:{"role":"status"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }